import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Skeleton } from "antd";
import { GiSofa } from "react-icons/gi";
import { Pagination, Autoplay } from "swiper/modules";

const MainPageCarousal = ({ MainBanners, SkeletonLoad }) => {
  const skeletonArray = Array.from({ length: 1 }, (_, index) => index);

  return (
    <div className="flex w-full">
      <div className="h-[42vh] min-h-[240px] max-h-[420px] w-full">
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper h-full w-full"
        >
          {SkeletonLoad ? (
            <div className="h-full w-full">
              {skeletonArray.map((index) => (
                <div key={index}>
                  <Skeleton.Node
                    active={true}
                    style={{ height: "100%", width: "100%" }}
                  >
                    <GiSofa style={{ fontSize: 300, color: "#bfbfbf" }} />
                  </Skeleton.Node>
                </div>
              ))}
            </div>
          ) : (
            MainBanners.map((el, i) => {
              if (el.device === "2") {
                return (
                  <SwiperSlide key={i} className="h-full w-full">
                    <img
                      src={process.env.REACT_APP_HAPS_MEDIA_BASE_URL + el.path}
                      alt="Fina Interior banner"
                      className="h-full w-full object-cover"
                    />
                  </SwiperSlide>
                );
              } else {
                return null;
              }
            })
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default MainPageCarousal;
